import { render, staticRenderFns } from "./AdminCouponTabularHeader.vue?vue&type=template&id=0051c30e&"
import script from "./AdminCouponTabularHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminCouponTabularHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports